<template>
  <Select
    v-model="date"
    @change="handleChange"
  >
    <Option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    />
  </Select>
</template>

<script>
import { Select, Option } from 'element-ui';

export default {
  components: {
    Select,
    Option,
  },

  model: {
    prop: 'value',
    event: 'change',
  },

  props: {
    value: {
      type: String,
      default: 'day',
    },
  },

  data() {
    return {
      options: [
        {
          value: 'day',
          label: '按日汇总',
        },
        {
          value: 'week',
          label: '按周汇总',
        },
        {
          value: 'month',
          label: '按月汇总',
        },
      ],
      date: this.value,
    };
  },

  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>
